<div class="panel">
    <div class="panel-body">
        <div class="panel-title"><h2>About Deal Jackets</h2></div>
        <p>
            Deal Jackets can be used to collect and store documents related to the purchase or lease of a vehicle. Used as a stand-alone tool or as a complement
            to other tools, there are a wide variety of applications for Deal Jackets, including:
        </p>
        <ul>
            <li>
                Processing a deal completely through the application, including consumer document uploads and e-signing, for both in-store and remote customers.
            </li>
            <li>Processing a deal for a remote buyer or Co-Buyer only, including consumer document uploads and e-signing.</li>
            <li>
                Adding a document that needs to be e-signed after a customer has left the store (e.g., if an error was discovered or a document was missed when
                the deal was completed).
            </li>
            <li>
                Uploading documents that have already been signed so they can be shared with buyers and Co-Buyers using a web-based link instead of giving them
                hard copies or thumbdrives.
            </li>
            <li>Adding consumer documents like driver's licenses and stips in preparation for a deal, before the deal terms are finalized.</li>
            <li>Storing Deal Jackets that were created outside the application for easy access to deal information and documents in the future.</li>
        </ul>
        <p>Deal Jackets are organized into three categories: open, closed and archived:</p>
        <ul>
            <li><b>Open Deals:</b> deals that are still in process, waiting for all documents to be added and/or signed</li>
            <li><b>Closed Deals:</b> deals that have been completed by F&I and are awaiting review and sign-off by the accounting department</li>
            <li><b>Archived Deals:</b> deals that have been reviewed by the accounting department and booked for financing</li>
        </ul>
        <div class="highlight">
            <b>NOTE:</b> Changes can only be made to open and closed Deal Jackets. If a jacket has been archived, you will need to move it to closed before you
            can modify it.
        </div>
        <p>
            All Deal Jackets are displayed in cards that contain key deal details. You can search for a Deal Jacket in the open, closed and archived categories
            using the customer name, deal number, VIN, stock ID or Jacket ID (assigned by the application). To view and take action on a Deal Jacket, click the
            card.
        </p>
    </div>

    <!--Below video section will be brought back when business provides a video-->

    <!-- <div class="video-section">
        <div (click)="openVideo('Deals', 'DealsOverview.mp4')" class="image-wrap">
            <div class="image-overlay">
                <mat-icon class="play-icon">play_circle_outline</mat-icon>
            </div>
            <video [src]="this.envVideoUrl + 'DealsOverview.mp4' + '#t=4.8'"></video>
        </div>
        <div class="video-text">
            <h3>Creating Deal Jackets</h3>

            <p>
                {{ isReadMore ? fullDesc : shortDesc }}
                <button *ngIf="fullDesc.length >= 200" class="read-more-btn" (click)="readMore()">
                    {{ isReadMore ? 'Read Less' : 'Read More...' }}
                </button>
            </p>

            <button (click)="openVideo('Deals', 'DealsOverview.mp4')" class="extension-btn">See Video</button>
        </div>
    </div> -->

    <div class="panel-body">
        <h3>Creating Deal Jackets</h3>
        <p>{{fullDesc}}</p>

        <h3>Important notes about the Deals function and Deal Jackets:</h3>
        <ul>
            <li>
                If you want to use the Deals function for documents that involve printing data from your DMS or other systems, you will need the enhanced
                service package. Contact us at {{ supportEmail }} or {{ tenantSupportPhone }} to learn more.
            </li>
            <li>
                As soon as a Deal Jacket is created, the buyer and Co-Buyer will receive welcome messages to set up their accounts so they can view and act on
                documents.
            </li>
            <li>
                When a Deal Jacket is started from a Document Jacket, the documents in the Document Jacket become part of the Deal Jacket and the Document
                Jacket is deleted.
            </li>
            <li>
                Document Jackets are currently not shareable outside the application. If you want to give a customer access to uploaded documents, create a Deal
                Jacket.
            </li>
            <li>
                Some information can be changed after a Deal Jacket is created, but other information cannot. If any of the information that cannot be changed
                needs to be added or updated, you will have to delete an existing Deal Jacket and create a new one.
            </li>
            <ul>
                <li><b>Changes you can make:</b> updating buyer/Co-Buyer details, switching the buyer and Co-Buyer, changing the vehicle</li>
                <li>
                    <b>Changes you cannot make:</b> changing the name of the person who created the jacket, adding a deal number, adding a trade-in vehicle or
                    updating trade-in vehicle details
                </li>
            </ul>
        </ul>
        <p>
            For additional details on Deal Jackets and how to use them, check out the Learn More help and guidance on the Start Deal Jacket and Deal Jacket
            screens.
        </p>
    </div>
</div>
